import React from 'react';
import "./Styles/LandingPage.css";
import NavBar from '../NavBar';
import LandingPage from './Components/LandingPageRoute/LandingPage';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import Footer from '../Footer';

function LandingPageRoute() {
    return (
    <div className="LandingPageRoutePage">
        <div className="LandingPageRouteNavBar">      
            <NavBar/>
        </div>
        <div className="LandingPageRoute">
            <LandingPage/>
        </div>
        {/*
        <div className="LandingPageRouteFooter">      
            <Footer/>
        </div> */}
    </div>
    );
}

export default LandingPageRoute;